import { render, staticRenderFns } from "./InviraRolesCreate.vue?vue&type=template&id=31d2f47a"
import script from "./InviraRolesCreate.vue?vue&type=script&lang=js"
export * from "./InviraRolesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports